<template>
  <div class="content" v-if="confirmation">
    <div class="wrapper" id="printable" role="log" aria-live="polite">
      <v-btn flat :ripple="false" icon @click="print" id="printButton">
        <v-icon>print</v-icon>
      </v-btn>
      <h1 tabindex="0" ref="firstStep">{{messages.confirmationTitle}}</h1>
      <div class="info-text appointment-details">
        <div class="confirmation-row" style="margin-bottom: 10px;">{{messages.confirmationText}}</div>
        <div  class="confirmation-row" v-if="confirmation.externalId && configuration.showRef" id="cexternalid">
          <div class="confirmation-label">{{messages.commonBookingNumberText}}:</div>
          <div class="confirmation-info">{{confirmation.externalId}}</div>
        </div>
        <div  class="confirmation-row">
          <div class="confirmation-label"><span v-if="services.length > 1">{{messages.commonMultipleServicesText}}</span><span v-else>{{messages.commonServiceText}}</span>:</div>
          <div class="confirmation-info">
            <div v-for="(service, index) in services" :key="index" :id="'cservice' + (index + 1)">
              {{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name }}
              <div v-if="configuration.multiplePeopleEnabled && (service.adult || service.child)" class="confirmation-service-adult">
                 (<span v-if="service.adult">{{service.adult}} <span v-if="service.adult == 1">{{messages.commonAdultText}}</span><span v-else>{{messages.commonAdultsText}}</span></span>
                <span v-if="service.adult && service.child">,</span>
                <span v-if="service.child">{{service.child}} <span v-if="service.child == 1">{{messages.commonChildText}}</span><span v-else>{{messages.commonChildrenText}}</span></span>)
              </div>
            </div>
          </div>
        </div>
        <div  class="confirmation-row" id="cbranch">
          <div class="confirmation-label">{{messages.commonLocationText}}:</div>
          <div class="confirmation-info">{{branchTranslations[confirmation.branch.id] && branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] ? branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] : confirmation.branch.name }}</div>
        </div>
        <div  class="confirmation-row" id="cdatetime">
          <div class="confirmation-label">{{messages.commonDateAndTimeText}}:</div>
          <div class="confirmation-info">{{confirmation.date | formatDate(selectedLanguage)}} {{confirmation.time | formatTime(selectedLanguage)}}</div>
        </div>
        <div class="confirmation-row" v-if="confirmation.customer.email" id="cemail">
          <div class="confirmation-label">{{messages.Email}}:</div>
          <div class="confirmation-info">{{confirmation.customer.email}}</div>
        </div>
        <div  class="confirmation-row" v-if="confirmation.customer.phone" id="cphone">
          <div class="confirmation-label">{{messages.Phone}}:</div>
          <div class="confirmation-info">+{{confirmation.customer.phone}}</div>
        </div>
        <div class="confirmation-row" v-if="checkShowPricesAndServicePrice" id="cserviceprice">
          <div class="confirmation-label">{{messages.totalCost}}:</div>
          <div class="confirmation-info">{{confirmation.totalCost}} {{messages.chooseServiceContentCurrency}}</div>
        </div>
        <div class="confirmation-row" v-if="checkShowPricesAndCondPrice" id="ccondprice">
          <div class="confirmation-label">{{messages.totalCost}}:</div>
          <div class="confirmation-info">{{confirmation.totalCost}} {{messages.chooseServiceContentCurrency}}</div>
        </div>
        <div  v-for="(field, index) in customFields" :key="index" :id="'ccustomfield' + (index + 1)">
            <div class="confirmation-row" v-if="configuration.customProperties && configuration.customProperties.enabled">         
              <div class="confirmation-label">{{field.label[selectedLanguage.lang]}}:</div>
              <div class="confirmation-info">{{getCustomFieldText(field.selection)}}</div>
            </div>
        </div>
        <div class="confirmation-row" v-if="checkShowTemplates" id="cservicetemplate" style="margin-top:10px;">
          <div ><strong>{{messages.confirmationTemplate}}</strong></div>
          <span v-html="serviceTemplateString"></span>
          </div>
        <img :src="qrCodeUrl" alt="Qr code" role="presentation" v-if="configuration.showQR">
      </div>
      <div class="info-text appointment-details primary-color" id="cbranchdata">
        <h2>{{branchTranslations[confirmation.branch.id] && branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] ? branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] : confirmation.branch.name }}
        </h2>
        <div v-if="confirmation.branch.phone" id="cbranchphone">
          <strong>{{messages.branchPhoneTitle}}:</strong>
          {{confirmation.branch.phone}}
        </div>
        <div v-if="confirmation.branch.email" id="cbranchemail">
          <strong>{{messages.branchEmailTitle}}:</strong>
          {{confirmation.branch.email}}
        </div>
        <div id="cbranchaddress">
          <strong>{{messages.branchAddressTitle}}:</strong>
          {{getBranchAddressBranchCard(confirmation.branch)}}
        </div>
      </div>
    </div>
    <v-btn
      :ripple="false"
      class="submit back"
      flat
      @click="backToStart"
      id="backtostartButton"
    >{{messages.backToStartPageButtonText}}</v-btn>

  </div>

</template>

<script>
import QRCode from 'qrcode'
import { mapState } from 'vuex'
import FormatService from '../services/formatService'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'Confirmation',
  mixins: [ FormatService ],
  props: [
    'confirmation',
    'urlParams',
    'startPage',
    'focusEventKey'
  ],
  data: () => ({
    qrCodeUrl: null,
    services: [],
    serviceTemplateString: ''
  }),
  computed: {
    ...mapState([
      'configuration',
      'servicesTranslations',
      'branchTranslations',
      'messages',
      'selectedLanguage',
      'customFields',
      'funcDebug',
      'serviceTemplates'
    ]),
    checkShowPricesAndCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'conditionalPrice'
    },
    checkShowPricesAndServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'servicesPrice'
    },
    checkShowTemplates () {
      return this.serviceTemplateString.length > 0
    }
  },
  watch: {
    focusEventKey () {
      if (this.funcDebug) console.log('Confirmation:watch:focusEventKey')
      this.$refs.firstStep.focus()
    },
    selectedLanguage () {
      this.fillServiceTemplates()
    }
  },
  methods: {
    getCustomFieldText (fieldSelection) {
      if (this.funcDebug) console.log('Confirmation:methods:getCustomFieldText')
      if (Array.isArray(fieldSelection)) {
        return fieldSelection.reduce((previousArray, currentValue) => {
          let myString = currentValue[this.selectedLanguage.lang]
          previousArray.push(myString)
          return previousArray
        }, []).join(', ')
      } else {
        return fieldSelection[this.selectedLanguage.lang] ? fieldSelection[this.selectedLanguage.lang] : fieldSelection
      }
    },
    backToStart () {
      if (this.funcDebug) console.log('Confirmation:methods:backToStart')
      var _this = this
      // configuration is not used by intention and resolves backend issues

      // clear the store
      this.$store.dispatch('resetBookingStore')
      // check for admin backUrl
      if (this.configuration && this.configuration.backUrl) {
        var url = this.configuration.backUrl ? this.configuration.backUrl : ''
        if (url) {
          location.replace(url)
        } else {
          let routingObj = {
            name: _this.startPage,
            params: _this.urlParams
          }
          eventHub.$emit('reload-configuration', routingObj)
        }
      } else {
        let routingObj = {
          name: _this.startPage,
          params: _this.urlParams
        }
        eventHub.$emit('reload-configuration', routingObj)
      }
    },
    print () {
      window.print()
    },
    fillServiceTemplates () {
      this.serviceTemplateString = ''
      var _this = this
      this.services.forEach((service) => {
        if (_this.serviceTemplates[service.qpId]) {
          var thisTemplate = (_this.serviceTemplates[service.qpId])[_this.selectedLanguage.lang]
          if (thisTemplate !== undefined) { _this.serviceTemplateString += thisTemplate }
        }
      })
    }
  },
  mounted () {
    if (this.funcDebug) console.log('Confirmation:mounted')
    var _this = this
    if (!this.confirmation) {
      this.backToStart()
    } else {
      if (this.confirmation.peopleServices.length > 0 && this.confirmation.peopleServices[0].name) {
        this.services = this.confirmation.peopleServices
      } else {
        this.services = this.confirmation.services
      }
      if (this.configuration.showQR) {
        QRCode.toDataURL(this.confirmation.externalId).then(url => {
          _this.qrCodeUrl = url
        })
      }
      this.fillServiceTemplates()
    }
  }
}
</script>

<style>
.confirmation-label{
  font-weight: bolder;
  width: 30%;
  float: left;
}
.confirmation-info{
  float: left;
  width: 70%;
  vertical-align: bottom;
}
.confirmation-row{
  overflow: auto;
}

@media print {
  .header,
  .submit.back {
    visibility: hidden;
  }
  #printable * {
    visibility: visible;
  }
  .primary-color {
    background-color: var(--primary-color) !important;
    color: var(--primary-bg-text-color) !important;
  }
}

@media only screen and (max-width: 450px) {
  .confirmation-label, .confirmation-info{
    width: 100% !important;
  }
}
</style>
